import Marquee from "react-fast-marquee";

export default function EditorialMarquee({ items, speed = 40 }) {
  const defaults = [
    "BRITISH COLUMBIA SECURITY SERVICES",
    "PROVINCE-WIDE PROTECTION",
    "LICENSED · BONDED · INSURED",
    "24 / 7 MOBILE PATROL",
    "SINCE 2011",
  ];
  const list = items || defaults;

  return (
    <div
      className="border-y border-black/10 bg-[#F4F4F0] py-6 select-none"
      data-testid="editorial-marquee"
    >
      <Marquee gradient={false} speed={speed} pauseOnHover={false}>
        {list.concat(list).map((item, i) => (
          <span
            key={i}
            className="font-mono text-2xl md:text-4xl lg:text-5xl tracking-tight text-[#060913] px-8 flex items-center gap-8"
          >
            {item}
            <span className="text-[#D92323]">✦</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
